import styled from 'styled-components';

interface ProgressBarContainerProps {
    fillColor: string;
}

interface ProgressBarFillProps {
    width: string;
    fillColor: string;
}

export const ProgressBarContainer = styled.div<ProgressBarContainerProps>`
    width: 100%;
    height: 12px;
    background-color: ${props => `${props.fillColor}30`};
    border-radius: 10px;
    overflow: hidden;
    position: relative;
`;

export const ProgressBarFill = styled.div<ProgressBarFillProps>`
    width: ${props => props.width};
    height: 100%;
    background-color: ${props => props.fillColor};
    border-radius: 10px;
    transition: width 0.3s ease-in-out;
`; 